import angular from 'angular';
import './styles.styl';
import uiCianTooltipAdapter from '../../adapters/ui.bootstrap.tooltip/tooltip.module';


export default angular
	.module('ui.cian.tooltip', [uiCianTooltipAdapter])

	.directive('cianUiTooltip', ['$uibTooltip', function ($uibTooltip) {
		return $uibTooltip('cianUiTooltip', 'tooltip', 'mouseenter');
	}])
	.directive('cianUiTooltipPopup', [function () {
		return {
			replace: true,
			scope: {
				content: '@',
				placement: '@',
				popupClass: '@',
				animation: '&',
				isOpen: '&'
			},
			templateUrl: 'uib/template/tooltip/tooltip-popup.html'
		};
	}])
	.directive('cianUiTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
		return $uibTooltip('cianUiTooltipHtml', 'tooltip', 'mouseenter', {
			placement: 'top-left',
			appendToBody: true,
			useContentExp: true
		});
	}])
	.directive('cianUiTooltipHtmlPopup', [function () {
		return {
			replace: true,
			scope: {
				contentExp: '&',
				placement: '@',
				popupClass: '@',
				animation: '&',
				isOpen: '&'
			},
			templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
		};
	}])
	.directive('cianUiTooltipDisable', ['$uibTooltip', function ($uibTooltip) {
		return $uibTooltip('cianUiTooltipDisable', 'tooltip', 'none');
	}])
	.directive('cianUiTooltipDisablePopup', [function () {
		return {
			replace: true,
			scope: {
				content: '@',
				placement: '@',
				popupClass: '@',
				animation: '&',
				isOpen: '&'
			},
			templateUrl: 'uib/template/tooltip/tooltip-popup.html'
		};
	}])
	.directive('cianUiTooltipTemplatePopup', [function () {
		return {
			replace: true,
			scope: {
				contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
				originScope: '&'
			},
			templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
		};
	}])
	.directive('cianUiTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
		return $uibTooltip('cianUiTooltipTemplate', 'tooltip', 'click', {
			useContentExp: true
		});
	}])
	.config(['$uibTooltipProvider', function ($uibTooltipProvider) {
		/**
		 * убираем анимацию для исправления ошибки связанной с биндингом текста в тултипе
		 * валидации полей, когда текст ошибки пропадает раньше чем закрывается тултип.
		 */
		$uibTooltipProvider.options({ animation: false });
	}])
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/tooltip/index.jsm